module.exports = __webpack_public_path__ + "img/notice-modal-de-DE.2a7d20ff.png";